import { Directive, OnInit, TemplateRef, ViewContainerRef, ElementRef, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appFlagInternal]'
})
export class FlagInternalDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    
  }

  ngOnInit() {
    this.update();
  }

  update() {
    if (environment.exportType === 'module') {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
